import { QueryClient } from '@tanstack/react-query';
import { isNormalizedGraphError } from '@/graph/errors';

/**
 * §6 throttling defence at the query layer. Retries transient throttles with
 * backoff, but never retries a consent/forbidden error (retrying those is useless
 * and just hammers Graph).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (isNormalizedGraphError(error)) {
          if (error.isConsentRequired || error.isForbidden) return false;
          if (error.isThrottled) return failureCount < 4;
        }
        return failureCount < 2;
      },
      retryDelay: (attempt, error) => {
        if (isNormalizedGraphError(error) && error.retryAfterSeconds) {
          return error.retryAfterSeconds * 1000;
        }
        return Math.min(1000 * 2 ** attempt, 15000);
      },
    },
  },
});
